<template>
    <v-app id="rating">
      <v-layout row>
       <v-flex lg12 class="px-lg-0 px-2 mt-15">
                                 
                 <v-layout row class="px-lg-0 px-10">

                     <v-flex lg3 xs12>

                             <v-row>
                           <div class="mt-lg-2"> <v-img src="@/assets/images/Monitoring/calendar.svg" /> </div>
                             <v-autocomplete
                             v-model="month"
                             :items="months"
                             item-text="month"
                             item-value="no"
                             dense
                            label="SELECT MONTH"
                            class="ml-lg-2"
                            @change="FilterDataTable()"
                            
                        ></v-autocomplete> 

                        </v-row>

                     </v-flex>
                     <v-flex lg3 xs12 class="ml-lg-10 mt-lg-0 mt-10">

                             <v-row>
                           <div class="mt-lg-2"> <v-img src="@/assets/images/Monitoring/calendar.svg" /> </div>
                             <v-autocomplete
                             v-model="year"
                             :items="years"
                             dense
                            label="SELECT YEAR"
                            class="ml-lg-2"
                            @change="FilterDataTable()"
                            
                        ></v-autocomplete> 

                        </v-row>

                     </v-flex>
                     
                     

                 </v-layout>  
                
                <v-layout row>
                 <v-flex lg6 xs12 class="font-weight-bold text-lg-h6 mt-10 px-lg-0 px-8 "> <div class="mt-lg-6"> Monthly Summary </div> </v-flex>

                 <v-flex lg4 xs8 class="font-weight-bold text-lg-h6 mt-10 px-14 ml-lg-16"> 
                    <v-card class="elevation-0 px-5 py-1 rounded-xl" color="rgb(219, 241, 254)" >

                            <v-layout>

                                <v-flex lg3 xs6>

                                    <span class="text-lg-body-2 font-xs-1 font-weight-bold" style="color:rgb(118, 118, 118)">
                                        <div class="mt-lg-1"> Monthly </div>
                                        <div> Average </div>
                                        <div> Score </div>
                                    </span>

                                </v-flex>
                                 <v-flex lg6 xs10 class="ml-10">

                                    <div class="text-lg-h3 text-h5 font-weight-bold mt-2 ml-lg-0 ml-n6" style="color:rgb(25, 118, 210)">
                                       {{totalAverage}}
                                    </div>

                                </v-flex>

                            </v-layout>

                    </v-card>    
                 </v-flex>
                  <v-flex lg1 xs2 class="font-weight-bold text-lg-h6 mt-10 ml-n10">       

                                    <ExcelTab style="height:0px" :tables-data="tablesData" :total-average="totalAverage" :file-name="FileName" :field-headers="excelFields"/>
                 </v-flex>
                </v-layout>
                               
                                    
               
               <v-flex lg12 class="mt-n5 mt-lg-10"> <v-data-table :loading="loadingStatus" loading-text="Loading... Please wait" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" dense :headers="headers" :footer-props="{'items-per-page-options': [20,40,60,80,100]}" :items-per-page="20"  :items="tables" item-key="name" class="elevation-0 table-rating">
                 

                                      <template v-slot:item.no="{ index }">
                                      
                                       <span> {{ index + 1 }} </span>
                                      
                                    </template>
                                     <template v-slot:item.cm="{ item }">

                                            <v-btn v-model="item.cm" depressed small color="primary" @click="openDialog(item.id,item.todate)"> Listen </v-btn>
                                      </template>



                                  </v-data-table> 
              </v-flex>
           </v-flex>

               
       </v-layout>
       

    </v-app>
</template>
<style scoped>
.searchinput{
  width:300px !important;
}
</style>
<script>
import ExcelTab from '@/components/MonitoringRating/excelReportMonthlyAverage'
import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'
Vue.use(axios)
export default {
    name: "LevelTest",
     components:{
      ExcelTab
    },
    data: () => ({
      FileName:'x',
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
          rowsPerPage: 20
        },
      tables: [],
        month:'',
        months: [{'no':'01','month':'January'}, {'no':'02','month':'February'}, {'no':'03','month':'March'}, {'no':'04','month':'April'}, {'no':'05','month':'May'}, {'no':'06','month':'June'}, {'no':'07','month':'July'}, {'no':'08','month':'August'}, {'no':'09','month':'September'}, {'no':'10','month':'October'}, {'no':'11','month':'November'}, {'no':'12','month':'December'},],
        monthno:'',
        year:'',
        menu: false,
        modal: false,
        menu2: false,
        ListGroup: null,
        errormsgDate: false,
        dialogshow:false,
        s_id:'',
        todate:'',
        StudentRecordData:'',
        call_date:'',
        phone_no:'',
        search:'',
        totalScore : 0 ,
        totalAverage:0,
        totalData: 0 ,
        tablesData:'',
        getTutor:[],
        excelFields: {
                    'Tutor':'tutor',
                    'Score':'score',
                },
       sortBy: 'score',
       sortDesc: true,
       loadingStatus:false,

    }),
    mounted(){

    },
    computed: {
       headers(){ return  [{

          
          text: 'No.',
          align: 'center',
          sortable: false,
          value: 'no',
        },
        { text: 'Tutor',sortable: false,
           filter:value=>{
           return value != null &&
          this.search != null &&
          typeof value === 'string' &&
          value.toString().toLowerCase().indexOf(this.search.toLowerCase()) !== -1},
          align: 'center', value: 'name' },
       { text: 'Score',sortable: false,align: 'center', value: 'score' }
       
        
        ]},
        years(){
          let x = 0
          let yearList = []
          let today = new Date()
          let yearToday = today.getFullYear()
          for(x=2021; x <=yearToday ; x++)
          {
            yearList.push(x)
          }
          return yearList
        },
    },
    methods:{
      
      FilterDataTable(){
        this.loadingStatus=true
        this.totalData=0
        this.totalScore=0
        this.tables=[]
        this.getTutor=[]
        this.dataTable()
    
      },
      getExcelData(){
        this.tablesData = this.tables
      },
      get2Digit(num){
        return ( num.toString().length < 2 ? "0"+num : num ).toString()
      },
      async dataTable(){
        await this.tables
        this.tables=[]
      axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getList')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          this.ListGroup = response.data
         
              for(let i = 0 ; i<=this.ListGroup.length ; i++){
                 
                


                        let timestamp = new Date(this.ListGroup[i].timestamp *1000)
                        let m = this.get2Digit(timestamp.getMonth('m')+1)
                        let DateCheck = m+"-"+timestamp.getFullYear()

                        let today = new Date()
                        // let year = today.getFullYear()
                        let monthCheck = this.month+"-"+this.year

                        let scoresFC   
                        scoresFC = this.ListGroup[i].type ==='FC' && typeof this.ListGroup[i].text.payload !== 'undefined' &&  this.ListGroup[i].text.payload.length >=4 ? (this.ListGroup[i].text.payload[0].Q1+this.ListGroup[i].text.payload[1].Q2+this.ListGroup[i].text.payload[2].Q3+this.ListGroup[i].text.payload[3].Q4)/4 : '0'
                        let scoresRC
                        scoresRC = this.ListGroup[i].type ==='RC' || this.ListGroup[i].type ==='MC'  ? this.ListGroup[i].score/2 : 0
                        let scoresAll = this.ListGroup[i].type ==='FC' ? scoresFC : scoresRC

                        if(DateCheck === monthCheck && scoresAll!=0 && (this.ListGroup[i].tutor_id!='dave11' && this.ListGroup[i].tutor_id!='nomal' && this.ListGroup[i].tutor_id!='test9999' && this.ListGroup[i].tutor_id!='jared11')){
                          

                        
                          let tutorID = this.ListGroup[i].tutor_id
                          this.totalScore = this.totalScore +  scoresAll
                          this.totalData = this.totalData +1
                          
                          if(this.getTutor.includes(tutorID)){
                        
                          let objIndex = this.tables.findIndex((obj => obj.tutor == tutorID));
                          let count =  this.tables[objIndex].tutorCount + 1
                          let lastVal = this.tables[objIndex].lastVal 
                          let score = (Math.round((parseFloat(lastVal) + parseFloat(scoresAll))*100 )/100) / count
                          this.tables[objIndex].score = Math.round((score + Number.EPSILON) * 100) / 100
                          this.tables[objIndex].tutorCount = count
                          this.tables[objIndex].lastVal = lastVal + scoresAll
                          this.tables.sort(function (a, b) {
                            return b.score - a.score;
                          });

                            
                          } else {

                                 
                                  this.getTutor.push(this.ListGroup[i].tutor_id)
                                  this.tables.push({
                                    tutor:this.ListGroup[i].tutor_id,
                                    name:this.ListGroup[i].tutor_full_name,
                                    score:scoresAll,
                                    lastVal:scoresAll,
                                    tutorCount: 1
                                    })

                          }
                        }
                        
                       
                        let x =   this.totalScore / this.totalData
                        this.totalAverage = isNaN(x) ? 0 : Math.round((x + Number.EPSILON) * 100) / 100
                        this.getExcelData()
                        this.FileName =  this.month+'-'+today.getFullYear()+'-rating-general-report'
                        this.loadingStatus=false


              }
              
               
            
              
        
        })
        

        
        
      },
     
    },
}
</script>
